<template>
  <div>
    <b-overlay center :show="isLoading" rounded="sm">
      <section class="cont bg-image">
        <div class="bck-animation-container">
          <div class="bck-animation-inner-container">
            <div class="bck-animation"></div>
          </div>
        </div>
        <div class="content">
          <div class="login-wrapper">
            <div class="login">
              <!-- <svg
                class="logo"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 990 280"
                height="40"
              >
                <defs>
                  <radialGradient
                    id="lw3_ssn"
                    cx="88.762"
                    cy="177.933"
                    fx="-122.46"
                    fy="151.523"
                    r="212.866"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset=".473" stop-color="#f1a41f" />
                    <stop offset="1" stop-color="#f05530" />
                  </radialGradient>
                </defs>
                <path
                  id="Path_1"
                  d="M319.606,84.149c-.274-3.995.89-7.957,3.282-11.169,2.69-2.67,6.402-4.047,10.183-3.779,3.776-.237,7.475,1.136,10.183,3.779,2.487,3.226,3.66,7.274,3.282,11.33v110.041c.304,4.026-.928,8.017-3.45,11.169-2.642,2.641-6.293,4.018-10.021,3.779-3.771.205-7.458-1.163-10.183-3.779-2.461-3.177-3.631-7.166-3.276-11.169v-110.202Z"
                  style="fill: #604c3b"
                />
                <path
                  id="Path_2"
                  d="M370.687,83.491c-.028-3.788,1.518-7.418,4.269-10.021,2.623-2.724,6.24-4.265,10.021-4.269,7.846-.17,14.345,6.052,14.515,13.898.17,7.846-6.052,14.345-13.898,14.515-.206.005-.411.005-.617,0-3.781-.003-7.399-1.545-10.021-4.269-2.718-2.557-4.262-6.122-4.269-9.854ZM398.442,194.358c.304,4.026-.928,8.017-3.45,11.169-2.642,2.641-6.293,4.018-10.021,3.779-3.771.205-7.458-1.163-10.183-3.779-2.463-3.176-3.635-7.166-3.282-11.169v-74.238c-.27-4.045.892-8.056,3.282-11.33,2.647-2.736,6.391-4.125,10.183-3.779,3.776-.237,7.475,1.136,10.183,3.779,2.438,3.251,3.605,7.28,3.282,11.33v74.238h.007Z"
                  style="fill: #604c3b"
                />
                <path
                  id="Path_3"
                  d="M454.61,167.086c-9.815-1.634-19.102-5.575-27.097-11.498-5.358-4.774-8.259-11.722-7.887-18.888-.316-9.457,3.818-18.515,11.169-24.473,8.704-6.447,19.391-9.644,30.205-9.035,9.705-.315,19.325,1.891,27.923,6.404,6.395,2.586,10.781,8.562,11.33,15.438.101,2.932-1.101,5.758-3.282,7.719-2.157,2.08-5.06,3.205-8.055,3.121-4.749-.757-9.157-2.933-12.646-6.242l-2.135-1.644c-1.807-1.345-3.877-2.296-6.075-2.792-2.338-.744-4.775-1.131-7.229-1.148-3.913-.233-7.819.561-11.33,2.302-2.424,1.51-3.857,4.2-3.759,7.055.043,2.393,1.358,4.583,3.45,5.746,5.044,2.22,10.338,3.82,15.767,4.766l8.377,1.806c9.738,1.428,18.983,5.204,26.936,11.001,5.336,4.916,8.172,11.976,7.719,19.217.59,10.194-3.976,20.004-12.156,26.117-10.466,6.65-22.77,9.813-35.145,9.035-10.386.37-20.672-2.132-29.729-7.229-6.852-3.263-11.384-9.997-11.827-17.573-.203-6.51,4.909-11.953,11.419-12.156.245-.008.491-.008.736,0,4.827.535,9.222,3.03,12.156,6.9l2.624,2.953c2.072,2.123,4.595,3.752,7.383,4.766,3.449,1.09,7.057,1.589,10.672,1.477,4.268.251,8.524-.658,12.317-2.631,2.7-1.461,4.35-4.315,4.269-7.384,0-4.269-5.256-7.558-15.606-10.183-.178.009-.352-.049-.49-.161l-10.008-2.786Z"
                  style="fill: #604c3b"
                />
                <path
                  id="Path_4"
                  d="M609.328,131.611v60.934c.066,1.162.23,2.316.49,3.45l.49,4.927c.127,2.857-1.015,5.624-3.121,7.558-2.398,1.963-5.443,2.959-8.538,2.792-4.111.313-8.164-1.117-11.169-3.94-2.694-3.451-3.984-7.793-3.611-12.156-3.313,5.088-7.899,9.222-13.304,11.988-5.983,2.91-12.565,4.372-19.217,4.269-8.314.497-16.46-2.481-22.493-8.223-5.655-6.342-8.553-14.675-8.055-23.157-.49-7.704,1.902-15.314,6.712-21.352,6.375-5.883,14.402-9.667,22.996-10.84,3.45-.671,8.538-1.477,15.438-2.302,4.272-.323,8.505-1.037,12.646-2.134,1.484-.509,2.719-1.565,3.45-2.953.706-1.544,1.043-3.23.987-4.927.333-3.366-1.096-6.666-3.779-8.726-3.865-2.102-8.264-3.015-12.646-2.624-1.484.015-2.966.125-4.437.329-1.399.191-2.775.522-4.108.987-2.484.76-4.774,2.049-6.712,3.779l-3.121,3.121c-2.872,3.857-7.211,6.354-11.988,6.9-2.903.122-5.717-1.016-7.719-3.121-2.086-2.081-3.216-4.935-3.121-7.88.528-7.499,4.955-14.171,11.659-17.573,8.575-5.278,18.518-7.907,28.581-7.558,11.249-.668,22.459,1.836,32.353,7.229,7.384,4.452,11.735,12.591,11.337,21.204ZM583.539,158.058c-4.922,2.13-10.038,3.78-15.277,4.927-2.988.501-5.948,1.16-8.867,1.973-3.679.793-7.08,2.552-9.854,5.095-1.938,2.349-2.933,5.335-2.792,8.377-.145,3.375,1.244,6.634,3.779,8.867,2.934,2.321,6.615,3.488,10.35,3.282,6.101.273,12.045-1.986,16.425-6.242,4.267-4.518,6.519-10.573,6.242-16.781l-.007-9.498Z"
                  style="fill: #604c3b"
                />
                <path
                  id="Path_5"
                  d="M680.78,195.17c-.453,4.142-2.174,8.042-4.927,11.169-3.526,2.212-7.684,3.194-11.827,2.792-3.861.416-7.747-.514-11.001-2.631-2.911-3.228-4.847-7.215-5.585-11.498l-19.687-70.452-.987-3.94-.329-3.121c-.082-3.476,1.217-6.843,3.611-9.364,2.402-2.489,5.737-3.86,9.196-3.779,3.103-.158,6.134.971,8.377,3.121,2.418,2.558,4.07,5.745,4.766,9.196l13.962,59.786,11.33-57.652c.469-4.217,2.251-8.181,5.095-11.33,3.234-2.335,7.194-3.441,11.169-3.121,2.257-.079,4.515.146,6.712.671,1.657.36,3.189,1.154,4.437,2.302,2.806,3.257,4.629,7.245,5.256,11.498l12.156,57.484,13.962-59.947c.75-3.3,2.333-6.353,4.598-8.867,2.115-2.035,4.946-3.156,7.88-3.121,3.382-.189,6.698.994,9.196,3.282,2.259,2.384,3.444,5.587,3.282,8.867l-.329,2.953c-.055.666-.165,1.326-.329,1.973-.146.84-.371,1.665-.671,2.463l-19.875,70.956c-.739,4.233-2.677,8.166-5.585,11.33-6.864,3.724-15.146,3.724-22.01,0-2.844-3.167-4.675-7.113-5.256-11.33l-13.794-59.947-12.794,60.255Z"
                  style="fill: #f8991d"
                />
                <path
                  id="Path_6"
                  d="M800.997,164.293c-.096,3.522.462,7.031,1.644,10.35.914,2.859,2.427,5.49,4.437,7.719,1.838,2.087,4.136,3.718,6.712,4.766,2.886,1.094,5.948,1.652,9.035,1.644,1.484-.015,2.967-.125,4.437-.329,1.399-.191,2.775-.521,4.108-.987,2.526-.794,4.871-2.078,6.9-3.779l1.973-1.806c3.155-3.403,7.391-5.609,11.988-6.242,2.815-.079,5.542.987,7.558,2.953,2.033,1.848,3.17,4.482,3.121,7.229-.021,2.185-.586,4.331-1.644,6.242-1.268,2.398-2.934,4.563-4.927,6.404-4.526,4.13-9.832,7.314-15.606,9.364-6.425,2.298-13.214,3.41-20.036,3.282-13.156.55-25.869-4.813-34.655-14.619-9.024-11.216-13.587-25.369-12.814-39.743-.755-14.145,3.749-28.07,12.646-39.092,8.768-9.698,21.43-14.944,34.488-14.29,13.081-.615,25.824,4.267,35.145,13.465,9.037,9.801,13.771,22.815,13.143,36.132.358,3.266-.521,6.547-2.463,9.196-3.604,2.149-7.829,3.017-11.988,2.463h-53.215l.013-.322ZM840.74,146.56c.063-2.976-.438-5.937-1.477-8.726-.913-2.487-2.309-4.768-4.108-6.712-3.83-3.774-9.084-5.744-14.452-5.417-5.213-.267-10.293,1.704-13.961,5.417-1.883,1.909-3.338,4.197-4.269,6.712-1.079,2.832-1.636,5.836-1.644,8.867h39.911v-.141Z"
                  style="fill: #f8991d"
                />
                <path
                  id="Path_7"
                  d="M912.682,196.975c.162,3.33-1.021,6.585-3.282,9.035-2.497,2.289-5.813,3.473-9.196,3.282-3.728.239-7.379-1.137-10.021-3.779-2.392-3.212-3.556-7.174-3.282-11.169v-110.202c-.296-4.048.869-8.068,3.282-11.33,5.608-5.024,14.099-5.024,19.707,0,2.414,3.263,3.578,7.283,3.282,11.33v35.145c3.055-5.069,7.428-9.215,12.653-11.995,5.294-2.669,11.154-4.02,17.083-3.94,11.825-.111,22.968,5.522,29.89,15.109,8.149,11.36,12.254,25.124,11.659,39.092.623,13.87-3.488,27.539-11.659,38.763-7.085,9.504-18.356,14.959-30.205,14.619-5.908.205-11.759-1.216-16.915-4.108-5.295-3.232-9.743-7.68-12.975-12.975l-.02,3.121ZM935.84,126.678c-6.6-.344-12.921,2.69-16.781,8.055-7.664,14.137-7.664,31.191,0,45.328,3.9,5.173,10.117,8.066,16.586,7.719,6.452.329,12.61-2.723,16.257-8.055,4.292-6.928,6.301-15.027,5.746-23.157.41-7.725-1.662-15.379-5.914-21.842-3.557-5.243-9.564-8.282-15.895-8.041v-.007Z"
                  style="fill: #f8991d"
                />
                <circle
                  cx="138.722"
                  cy="140"
                  r="133.241"
                  style="fill: url(#lw3_ssn)"
                />
                <path
                  d="M191.626,215.426h-91.926c-12.263,0-22.205-9.942-22.205-22.205v-116.282c0-12.263,9.941-22.205,22.205-22.205s22.205,9.941,22.205,22.205v94.077h69.721c12.263,0,22.205,9.942,22.205,22.205s-9.942,22.205-22.205,22.205Z"
                  style="fill: #fff"
                />
              </svg> -->
              <div class="logos-login-wrapper">
                <svg
                  class="logo"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 990 280"
                  height="40"
                >
                  <path
                    d="M319.606,84.149c-.274-3.995.89-7.957,3.282-11.169,2.69-2.67,6.402-4.047,10.183-3.779,3.776-.237,7.475,1.136,10.183,3.779,2.487,3.226,3.66,7.274,3.282,11.33v110.041c.304,4.026-.928,8.017-3.45,11.169-2.642,2.641-6.293,4.018-10.021,3.779-3.771.205-7.458-1.163-10.183-3.779-2.461-3.177-3.631-7.166-3.276-11.169v-110.202Z"
                    style="fill: #11181c"
                  />
                  <path
                    d="M370.687,83.491c-.028-3.788,1.518-7.418,4.269-10.021,2.623-2.724,6.24-4.265,10.021-4.269,7.846-.17,14.345,6.052,14.515,13.898.17,7.846-6.052,14.345-13.898,14.515-.206.005-.411.005-.617,0-3.781-.003-7.399-1.545-10.021-4.269-2.718-2.557-4.262-6.122-4.269-9.854ZM398.442,194.358c.304,4.026-.928,8.017-3.45,11.169-2.642,2.641-6.293,4.018-10.021,3.779-3.771.205-7.458-1.163-10.183-3.779-2.463-3.176-3.635-7.166-3.282-11.169v-74.238c-.27-4.045.892-8.056,3.282-11.33,2.647-2.736,6.391-4.125,10.183-3.779,3.776-.237,7.475,1.136,10.183,3.779,2.438,3.251,3.605,7.28,3.282,11.33v74.238h.007Z"
                    style="fill: #11181c"
                  />
                  <path
                    d="M454.61,167.086c-9.815-1.634-19.102-5.575-27.097-11.498-5.358-4.774-8.259-11.722-7.887-18.888-.316-9.457,3.818-18.515,11.169-24.473,8.704-6.447,19.391-9.644,30.205-9.035,9.705-.315,19.325,1.891,27.923,6.404,6.395,2.586,10.781,8.562,11.33,15.438.101,2.932-1.101,5.758-3.282,7.719-2.157,2.08-5.06,3.205-8.055,3.121-4.749-.757-9.157-2.933-12.646-6.242l-2.135-1.644c-1.807-1.345-3.877-2.296-6.075-2.792-2.338-.744-4.775-1.131-7.229-1.148-3.913-.233-7.819.561-11.33,2.302-2.424,1.51-3.857,4.2-3.759,7.055.043,2.393,1.358,4.583,3.45,5.746,5.044,2.22,10.338,3.82,15.767,4.766l8.377,1.806c9.738,1.428,18.983,5.204,26.936,11.001,5.336,4.916,8.172,11.976,7.719,19.217.59,10.194-3.976,20.004-12.156,26.117-10.466,6.65-22.77,9.813-35.145,9.035-10.386.37-20.672-2.132-29.729-7.229-6.852-3.263-11.384-9.997-11.827-17.573-.203-6.51,4.909-11.953,11.419-12.156.245-.008.491-.008.736,0,4.827.535,9.222,3.03,12.156,6.9l2.624,2.953c2.072,2.123,4.595,3.752,7.383,4.766,3.449,1.09,7.057,1.589,10.672,1.477,4.268.251,8.524-.658,12.317-2.631,2.7-1.461,4.35-4.315,4.269-7.384,0-4.269-5.256-7.558-15.606-10.183-.178.009-.352-.049-.49-.161l-10.008-2.786Z"
                    style="fill: #11181c"
                  />
                  <path
                    d="M609.328,131.611v60.934c.066,1.162.23,2.316.49,3.45l.49,4.927c.127,2.857-1.015,5.624-3.121,7.558-2.398,1.963-5.443,2.959-8.538,2.792-4.111.313-8.164-1.117-11.169-3.94-2.694-3.451-3.984-7.793-3.611-12.156-3.313,5.088-7.899,9.222-13.304,11.988-5.983,2.91-12.565,4.372-19.217,4.269-8.314.497-16.46-2.481-22.493-8.223-5.655-6.342-8.553-14.675-8.055-23.157-.49-7.704,1.902-15.314,6.712-21.352,6.375-5.883,14.402-9.667,22.996-10.84,3.45-.671,8.538-1.477,15.438-2.302,4.272-.323,8.505-1.037,12.646-2.134,1.484-.509,2.719-1.565,3.45-2.953.706-1.544,1.043-3.23.987-4.927.333-3.366-1.096-6.666-3.779-8.726-3.865-2.102-8.264-3.015-12.646-2.624-1.484.015-2.966.125-4.437.329-1.399.191-2.775.522-4.108.987-2.484.76-4.774,2.049-6.712,3.779l-3.121,3.121c-2.872,3.857-7.211,6.354-11.988,6.9-2.903.122-5.717-1.016-7.719-3.121-2.086-2.081-3.216-4.935-3.121-7.88.528-7.499,4.955-14.171,11.659-17.573,8.575-5.278,18.518-7.907,28.581-7.558,11.249-.668,22.459,1.836,32.353,7.229,7.384,4.452,11.735,12.591,11.337,21.204ZM583.539,158.058c-4.922,2.13-10.038,3.78-15.277,4.927-2.988.501-5.948,1.16-8.867,1.973-3.679.793-7.08,2.552-9.854,5.095-1.938,2.349-2.933,5.335-2.792,8.377-.145,3.375,1.244,6.634,3.779,8.867,2.934,2.321,6.615,3.488,10.35,3.282,6.101.273,12.045-1.986,16.425-6.242,4.267-4.518,6.519-10.573,6.242-16.781l-.007-9.498Z"
                    style="fill: #11181c"
                  />
                  <path
                    d="M680.78,195.17c-.453,4.142-2.174,8.042-4.927,11.169-3.526,2.212-7.684,3.194-11.827,2.792-3.861.416-7.747-.514-11.001-2.631-2.911-3.228-4.847-7.215-5.585-11.498l-19.687-70.452-.987-3.94-.329-3.121c-.082-3.476,1.217-6.843,3.611-9.364,2.402-2.489,5.737-3.86,9.196-3.779,3.103-.158,6.134.971,8.377,3.121,2.418,2.558,4.07,5.745,4.766,9.196l13.962,59.786,11.33-57.652c.469-4.217,2.251-8.181,5.095-11.33,3.234-2.335,7.194-3.441,11.169-3.121,2.257-.079,4.515.146,6.712.671,1.657.36,3.189,1.154,4.437,2.302,2.806,3.257,4.629,7.245,5.256,11.498l12.156,57.484,13.962-59.947c.75-3.3,2.333-6.353,4.598-8.867,2.115-2.035,4.946-3.156,7.88-3.121,3.382-.189,6.698.994,9.196,3.282,2.259,2.384,3.444,5.587,3.282,8.867l-.329,2.953c-.055.666-.165,1.326-.329,1.973-.146.84-.371,1.665-.671,2.463l-19.875,70.956c-.739,4.233-2.677,8.166-5.585,11.33-6.864,3.724-15.146,3.724-22.01,0-2.844-3.167-4.675-7.113-5.256-11.33l-13.794-59.947-12.794,60.255Z"
                    style="fill: var(--lisaweb)"
                  />
                  <path
                    d="M800.997,164.293c-.096,3.522.462,7.031,1.644,10.35.914,2.859,2.427,5.49,4.437,7.719,1.838,2.087,4.136,3.718,6.712,4.766,2.886,1.094,5.948,1.652,9.035,1.644,1.484-.015,2.967-.125,4.437-.329,1.399-.191,2.775-.521,4.108-.987,2.526-.794,4.871-2.078,6.9-3.779l1.973-1.806c3.155-3.403,7.391-5.609,11.988-6.242,2.815-.079,5.542.987,7.558,2.953,2.033,1.848,3.17,4.482,3.121,7.229-.021,2.185-.586,4.331-1.644,6.242-1.268,2.398-2.934,4.563-4.927,6.404-4.526,4.13-9.832,7.314-15.606,9.364-6.425,2.298-13.214,3.41-20.036,3.282-13.156.55-25.869-4.813-34.655-14.619-9.024-11.216-13.587-25.369-12.814-39.743-.755-14.145,3.749-28.07,12.646-39.092,8.768-9.698,21.43-14.944,34.488-14.29,13.081-.615,25.824,4.267,35.145,13.465,9.037,9.801,13.771,22.815,13.143,36.132.358,3.266-.521,6.547-2.463,9.196-3.604,2.149-7.829,3.017-11.988,2.463h-53.215l.013-.322ZM840.74,146.56c.063-2.976-.438-5.937-1.477-8.726-.913-2.487-2.309-4.768-4.108-6.712-3.83-3.774-9.084-5.744-14.452-5.417-5.213-.267-10.293,1.704-13.961,5.417-1.883,1.909-3.338,4.197-4.269,6.712-1.079,2.832-1.636,5.836-1.644,8.867h39.911v-.141Z"
                    style="fill: var(--lisaweb)"
                  />
                  <path
                    d="M912.682,196.975c.162,3.33-1.021,6.585-3.282,9.035-2.497,2.289-5.813,3.473-9.196,3.282-3.728.239-7.379-1.137-10.021-3.779-2.392-3.212-3.556-7.174-3.282-11.169v-110.202c-.296-4.048.869-8.068,3.282-11.33,5.608-5.024,14.099-5.024,19.707,0,2.414,3.263,3.578,7.283,3.282,11.33v35.145c3.055-5.069,7.428-9.215,12.653-11.995,5.294-2.669,11.154-4.02,17.083-3.94,11.825-.111,22.968,5.522,29.89,15.109,8.149,11.36,12.254,25.124,11.659,39.092.623,13.87-3.488,27.539-11.659,38.763-7.085,9.504-18.356,14.959-30.205,14.619-5.908.205-11.759-1.216-16.915-4.108-5.295-3.232-9.743-7.68-12.975-12.975l-.02,3.121ZM935.84,126.678c-6.6-.344-12.921,2.69-16.781,8.055-7.664,14.137-7.664,31.191,0,45.328,3.9,5.173,10.117,8.066,16.586,7.719,6.452.329,12.61-2.723,16.257-8.055,4.292-6.928,6.301-15.027,5.746-23.157.41-7.725-1.662-15.379-5.914-21.842-3.557-5.243-9.564-8.282-15.895-8.041v-.007Z"
                    style="fill: var(--lisaweb)"
                  />
                  <circle
                    cx="138.722"
                    cy="140"
                    r="133.241"
                    style="fill: var(--lisaweb)"
                  />
                  <path
                    d="M191.626,215.426h-91.926c-12.263,0-22.205-9.942-22.205-22.205v-116.282c0-12.263,9.941-22.205,22.205-22.205s22.205,9.941,22.205,22.205v94.077h69.721c12.263,0,22.205,9.942,22.205,22.205s-9.942,22.205-22.205,22.205Z"
                    style="fill: #fff"
                  />
                </svg>
                <template v-if="computePd === 'true'">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    viewBox="0 0 122.878 122.88"
                  >
                    <path
                      d="M1.426,8.313c-1.901-1.901-1.901-4.984,0-6.886c1.901-1.902,4.984-1.902,6.886,0l53.127,53.127l53.127-53.127 c1.901-1.902,4.984-1.902,6.887,0c1.901,1.901,1.901,4.985,0,6.886L68.324,61.439l53.128,53.128c1.901,1.901,1.901,4.984,0,6.886 c-1.902,1.902-4.985,1.902-6.887,0L61.438,68.326L8.312,121.453c-1.901,1.902-4.984,1.902-6.886,0 c-1.901-1.901-1.901-4.984,0-6.886l53.127-53.128L1.426,8.313L1.426,8.313z"
                    />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 111.255 45"
                    height="40"
                  >
                    <path
                      d="M78.203 27.9c0-8.88 6.719-15.899 16.019-15.899s16.02 7.02 16.02 15.899-6.72 15.899-16.02 15.899-16.019-7.02-16.019-15.899zm23.305 2.314c1.085-4.93-2.093-9.615-6.863-9.666-3.395-.036-6.331 2.478-7.073 5.791-1.106 4.937 2.16 9.628 6.945 9.66 3.372.023 6.266-2.492 6.991-5.785z"
                      fill-opacity=".5"
                      opacity=".7"
                    />
                    <g fill="var(--lisaweb)">
                      <path
                        d="M40.013,5.284c0-2.275,1.886-4.083,4.26-4.083s4.26,1.808,4.26,4.083v33.832c0,2.275-1.886,4.083-4.26,4.083s-4.26-1.808-4.26-4.083V5.284Z"
                        fill-opacity=".5"
                      />
                      <path
                        d="M15.814 27.562c0-9.068 6.862-16.237 16.36-16.237s16.359 7.169 16.359 16.237-6.862 16.237-16.359 16.237-16.36-7.169-16.36-16.237zm24.168.343c0-4.374-3.116-8.09-7.49-8.09s-7.551 3.715-7.551 8.09 3.176 8.09 7.551 8.09 7.49-3.715 7.49-8.09z"
                        fill-opacity=".5"
                      />
                    </g>
                    <circle cx="102.113" cy="19.138" r="4.321" fill="#121922" />
                    <g fill="var(--lisaweb)">
                      <path
                        d="M15.799 1.201H5.72c-2.46 0-4.5 2.039-4.5 4.499v33.599c0 2.46 2.04 4.5 4.5 4.5s4.5-2.04 4.5-4.5V27.585h5.58c8.157 0 13.795-5.936 13.799-13.192C29.595 7.137 23.957 1.201 15.8 1.201h-.001zm-.3 17.985h-5.28V9.601h5.28c2.637 0 4.795 2.156 4.799 4.793-.004 2.636-2.162 4.793-4.799 4.793h0z"
                        fill-opacity=".5"
                      />
                      <circle cx="26.503" cy="38.412" r="4.104" />
                      <path
                        d="M29.598,14.371c0-.969-.109-1.911-.302-2.822-7.971,1.29-13.482,7.87-13.482,15.991,0,.007.001.015.001.022,8.148-.008,13.78-5.94,13.783-13.191Z"
                      />
                    </g>
                    <path
                      d="M87.549,26.503c.005-.022.006-.044.011-.065.257-1.36.392-2.768.392-4.214,0-2.952-.557-5.749-1.593-8.285-4.991,2.674-8.156,7.891-8.156,13.985,0,3.686,1.171,7.041,3.191,9.717,3.154-2.906,5.311-6.753,6.155-11.137h0Z"
                      fill="#121922"
                    />
                    <path
                      d="M66.262 1.201h-6.318c-.01 0-.02-.003-.03-.003A4.2 4.2 0 0 0 55.8 4.56c-.076.302-.127.613-.136.937h-.007v.072c0 .016-.005.03-.005.046s.004.03.005.046v10.343c0 .016.005.031.005.048l-.004.043c.003.507.1.986.256 1.434.025.071.038.148.068.218.015.037.038.069.055.106.66 1.455 2.117 2.471 3.819 2.471.052 0 .1-.013.151-.015s.098.015.15.015a3.9 3.9 0 0 0 3.899-3.899V9.6h2.207c7.739 0 12.359 5.58 12.359 12.6s-4.62 12.6-12.359 12.6H52.626v8.399h13.637c12.959 0 21.659-9.3 21.659-20.999S79.221 1.201 66.262 1.201z"
                      fill-opacity=".5"
                      opacity=".7"
                    />
                    <path
                      d="M55.358,34.787h-8.45c1.038-2.171,1.624-4.617,1.624-7.229,0-6.299-3.315-11.674-8.52-14.374l-.014,25.802c0,2.339,1.782,4.199,4.025,4.199h11.335c2.242,0,4.025-1.859,4.025-4.199s-1.782-4.199-4.025-4.199Z"
                      fill="var(--lisaweb)"
                    />
                  </svg>
                </template>
              </div>
              <template v-if="!isLoading">
                <h1 class="title">Credenziali di accesso utente</h1>
                <validation-observer
                  ref="observer"
                  v-slot="{ invalid, handleSubmit }"
                >
                  <b-form
                    autocomplete="on"
                    @submit.prevent="handleSubmit(onSubmit)"
                  >
                    <div class="mt-5">
                      <base-input
                        name="username"
                        :label="beForm[rep].username.label"
                        v-model="form.username"
                        :rules="getRules('username', 'auth')"
                        placeholder="Inserisci il nome utente"
                        autocomplete="username"
                      />
                      <base-input
                        name="password"
                        :label="beForm[rep].password.label"
                        type="password"
                        v-model="form.password"
                        :rules="getRules('password', 'auth')"
                        placeholder="Inserisci la password"
                        autocomplete="current-password"
                      />
                      <!-- <div style="font-size: 0.75rem">
                    <b-link
                      href="forgot-password"
                      @click.prevent="forgotPassword()"
                    >
                      <span>Password dimenticata?</span>
                    </b-link>
                  </div> -->
                      <div style="display: flex; justify-content: center">
                        <b-button
                          type="submit"
                          variant="lisaweb"
                          size="sm"
                          :disabled="invalid"
                          >{{ beForm["auth"].submit.label }}
                        </b-button>
                      </div>
                    </div>
                  </b-form>
                </validation-observer>
                <Info></Info>
              </template>
              <template v-else>
                <div class="inner-overlay text-center">
                  <div class="custom-loader"></div>
                  <!-- <base-icon name="loading" width="35" height="35" /> -->
                  <p id="cancel-label">{{ msg || "Operazione in corso..." }}</p>
                </div>
              </template>
            </div>
          </div>
        </div>
      </section>
      <template #overlay>
        <!-- <div class="text-center">
          <base-icon name="loading" width="35" height="35" />
          <p id="cancel-label">{{ msg || "Operazione in corso..." }}</p>
        </div> -->
      </template>
    </b-overlay>
  </div>
</template>

<script>
// import BaseIcon from "@/components/BaseIcon";
import BaseInput from "@/components/form/BaseInput";
import Info from "@/components/Info";
import FormMixin from "@/mixins/FormMixin";
import { mapGetters } from "vuex";
import { canModule, canVerb } from "@/utils/permissions";
import { isPoldo } from "@/utils/theme";

export default {
  mixins: [FormMixin],
  data() {
    return {
      isLoading: true,
      form: {
        username: "",
        password: "",
      },
      show: true,
      messages: [
        "Caricamento dati in corso...",
        "Questa operazione potrebbe impiegare alcuni secondi...",
        "Attendere prego...",
      ],
      delay: 6000,
      codeAgency: /(?:www.)?(\w+)(\..*)+/.exec(window.location.hostname)[1],
    };
  },
  components: {
    // BaseIcon,
    BaseInput,
    Info,
  },
  mounted() {
    this.isLoading = true;
    this.fetchCreateForm("auth").then(() => {
      this.isLoading = false;
    });
  },

  methods: {
    canModule,
    canVerb,
    onSubmit() {
      this.loadMsg();
      this.isLoading = true;
      this.$store.commit("sidebar/SIDEBAR_LOCKED_SAVE", true);

      this.$store
        .dispatch("auth/login", {
          // email: this.form.email,
          username: this.form.username,
          password: this.form.password,
        })
        .then(() => {
          if (/Edg\//.test(navigator.userAgent) && window.PasswordCredential) {
            const cred = new window.PasswordCredential({
              id: this.form.username,
              password: this.form.password,
              /* you can optionally provide the formElement:
              form: document.getElementById('loginForm')
              */
            });
            navigator.credentials.store(cred).catch(console.error);
          }
          // if at least 1 error, redirect to Login
          // let agency_brokers = this.$store.dispatch("auth/agency_brokers");
          // let book_tags = this.$store.dispatch("auth/book_tags");
          let branches = this.$store.dispatch("auth/branches");
          // let cooperators = this.$store.dispatch("auth/cooperators");
          // let councils = this.$store.dispatch("auth/councils");
          // let countries = this.$store.dispatch("auth/countries");
          // let insurers = this.$store.dispatch("auth/insurers");
          // let bank_accounts = this.$store.dispatch("auth/bank_accounts");
          // let mandate_codes = this.$store.dispatch("auth/mandate_codes");
          // let payment_refrences = this.$store.dispatch("auth/payment_references");
          let products = this.$store.dispatch("auth/products");
          // let provinces = this.$store.dispatch("auth/provinces");
          // let relative_types = this.$store.dispatch("auth/relative_types");
          let cash_references = this.$store.dispatch("auth/cash_references");
          // let lisa_for_apps = this.$store.dispatch("auth/lisa_for_apps");
          // let reports = this.$store.dispatch("auth/reports");
          let risks = this.$store.dispatch("auth/risks");
          let salesmen = this.$store.dispatch("auth/salesmen");
          let sectors = this.$store.dispatch("auth/sectors");
          let treasuries = this.$store.dispatch("auth/treasuries");
          // let conti_prima_nota = this.$store.dispatch("auth/conti_prima_nota");
          // let users = this.$store.dispatch("auth/users");

          let promises = [
            // agency_brokers,
            // book_tags,
            branches,
            cash_references,
            // cooperators,
            // councils,
            // countries,
            // insurers,
            // bank_accounts,
            // lisa_for_apps,
            // mandate_codes,
            // payment_refrences,
            products,
            // provinces,
            // relative_types,
            // reports,
            risks,
            salesmen,
            sectors,
            treasuries,
            // conti_prima_nota,
            // users,
          ];

          // conditional dispatch:
          if (canVerb("import_maps", "index")) {
            let count_import_maps = this.$store.dispatch("auth/counters", {
              resource: "import_maps",
              query: "byTreasury[id]=!&count",
            });
            promises.push(count_import_maps);
          }

          if (
            canModule("module.PROF.SEPA") &&
            canVerb("bank_accounts", "index")
          ) {
            let bank_accounts = this.$store.dispatch("auth/bank_accounts");
            promises.push(bank_accounts);
          }
          if (
            canModule("module.HOME.LAPP") &&
            canVerb("lisa_for_apps", "index")
          ) {
            let lisa_for_apps = this.$store.dispatch("auth/lisa_for_apps");
            promises.push(lisa_for_apps);
          }

          Promise.all(promises)
            .then(() => {
              // han deciso che devo caricare la dashborad solo dopo che l'ultima promise ha finito
              this.$router.replace({ name: "module.HOME" });
              this.$store.commit("sidebar/SIDEBAR_LOCKED_SAVE", false);
              document.body.className = "logged";
            })
            .catch((error) => {
              let errMsg = this.$getErrorMessage(error);
              this.$showSnackbar({ preset: "error", text: errMsg });
            })
            .finally(() => {
              this.unloadMsg();
              this.isLoading = false;
            });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
          this.isLoading = false; // when wrong password, must stop loading...
        });
      // .finally(() => {
      //   this.unloadMsg();
      //   this.isLoading = false; // when wrong password, must stop loading...
      // });
    },
    forgotPassword() {
      // this.$showSnackbar({
      //   preset: "info",
      //   text: "Si è scelto di resettare la password",
      // });
      this.$router.replace({ name: "ForgotPassword" });
      // this.$router.replace({ name: "ResetPassword" });
    },
  },
  computed: {
    ...mapGetters("login_data", ["isLoginData"]),
    ...mapGetters("auth", ["isLogged", "permissions"]),
    // ver() {
    //   return this.version;
    // },
    // bu() {
    //   return `http://${window.location.hostname.split(".")[0]}.${
    //     process.env.VUE_APP_BASE_URL
    //   }`;
    // },
    // cliVer() {
    //   return process.env.VUE_APP_VERSION || "0";
    // },
    rep() {
      return "auth";
    },
    formFilled() {
      return !(this.form.username || this.form.password);
    },
    computePd() {
      return isPoldo() ? "true" : "false";
    },
  },
};
</script>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.logos-login-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 40px;
}

.cont {
  display: flex;
  height: 100vh;
  margin-left: 0 !important;
  padding-left: 0 !important;
}

.content {
  flex: 2;
  height: 100%;
  overflow: auto;
}

.cont.bg-image {
  position: fixed;
  width: 100%;
  height: 100%;
}

.cont.bg-image .content {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-wrapper {
  padding: 8px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: calc(2rem + 8px);
  background: rgba(0, 0, 0, 0.04);
  backdrop-filter: blur(10px);
}

.login {
  position: relative;
  // background: rgba(255, 255, 255, 0.8);
  background: #fff;
  // box-shadow: 6px 12px 60px rgba(0, 0, 0, 0.2);
  border-radius: 2rem;
  // border: 1px solid rgba(255, 255, 255, 0.125);
  margin: 0 auto;
  width: 90vw;
  padding: 20px 30px 20px 30px;
  min-height: 520px;
  // padding: 20px 40px 30px 40px;
}

.inner-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  translate: -50% -50%;
}

.cont.bg-image .content .title {
  font-size: 1rem;
  font-weight: 500;
  color: var(--color-text);
  text-align: center;
  margin-bottom: 0;
}

@media screen and (min-width: 480px) {
  .cont.bg-image .content .title {
    font-size: 1.25rem;
  }
}

@media screen and (min-width: 767px) {
  .login {
    min-width: 350px;
    width: auto;
    max-width: 500px;
    padding: 20px 40px;
  }
  // .cont.bg-image .content .title {
  //   font-size: 1.5rem;
  // }
}
</style>
<style>
.cont.bg-image + .b-overlay.position-absolute {
  display: none !important;
}

.cont.bg-image .form-control:-webkit-autofill,
.cont.bg-image .form-control:-webkit-autofill::first-line,
.cont.bg-image .form-control:-webkit-autofill:hover,
.cont.bg-image .form-control:-webkit-autofill:focus,
.cont.bg-image .form-control:-webkit-autofill:focus-visible {
  font-family: var(--font-family);
  -webkit-background-clip: text !important;
}

/* .cont.bg-image + .b-overlay.position-absolute .bg-light {
  opacity: 1 !important;
  backdrop-filter: none !important;
  background: 0 !important;
} */
/* .cont.bg-image .logo {
  display: block;
  margin: 10px auto 25px;
} */

.cont.bg-image .form-group label {
  font-weight: 500;
  margin-bottom: 0.2rem;
  font-size: var(--font-size-sm);
}

.cont.bg-image .form-control {
  height: 47px;
  padding: 0 1rem !important;
  font-size: var(--font-size-md);
  border-radius: 10px;
}

.cont.bg-image .form-control::placeholder {
  font-size: var(--font-size-md);
}

.cont.bg-image .btn-lisaweb {
  width: 100%;
  height: 47px;
  font-size: 15px;
  /* font-size: 14px; */
  margin-top: 0.3rem;
  border-radius: 10px;
  font-weight: 500;
}

@media (pointer: coarse) and (hover: none) {
  .cont.bg-image .form-control {
    font-size: var(--font-size-lg);
  }

  .cont.bg-image .form-control::placeholder {
    font-size: var(--font-size-lg);
  }
}

@media screen and (min-width: 767px) {
  .cont.bg-image .btn-lisaweb {
    height: 42px;
  }

  /* .cont.bg-image .form-control { */
  /*height: auto;
    padding: 0.375rem 0.75rem !important;*/
  /* font-size: 14px; */
  /* } */
  /* .cont.bg-image .form-control::placeholder { */
  /* font-size: 14px; */
  /* } */
  /*.cont.bg-image .btn-lisaweb {
    height: 33px;
    font-size: 12px;
    margin-top: 0.1rem;
  }
  .cont.bg-image .form-group label {
    font-size: 12px;
  }*/
}

/* .cont.bg-image + .b-overlay.position-absolute div {
  color: #fff;
} */

/* */
/* [aria-busy="true"] .bck-animation-container {
  opacity: 0;
} */
.bck-animation-container {
  /* background: #141414; */
  background-color: #fff;
  /* background: #604d3c; */
  position: fixed;
  width: 100%;
  height: 100%;
  overflow: hidden;
  /* transition: 0.4s opacity linear; */
  /*
   * https://www.freecodecamp.org/news/grainy-css-backgrounds-using-svg-filters/
   * https://grainy-gradients.vercel.app/
   */
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 600 600' style='opacity:.3'%3E%3Cfilter id='a'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23a)'/%3E%3C/svg%3E");
  background-size: 600px;
}

.bck-animation-inner-container {
  /* -webkit-filter: blur(250px);
  filter: blur(250px); */
  /* -webkit-filter: blur(200px); */
  filter: blur(200px);
  /* -webkit-transform: translate3d(0, 0, 0); */
  transform: translate3d(0, 0, 0);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.bck-animation {
  /* background: #ef693a; */
  /* background: #f79d34; */
  background: var(--lisaweb);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  height: 600px;
  border-radius: 50%;
  mix-blend-mode: lighten;
}

@media screen and (prefers-reduced-motion: no-preference) {
  div:not([aria-busy="true"]) .bck-animation {
    /* -webkit-animation-duration: 20s;
    animation-duration: 20s;
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    -webkit-animation-timing-function: cubic-bezier(0.1, 0, 0.9, 1);
    animation-timing-function: cubic-bezier(0.1, 0, 0.9, 1);
    -webkit-animation-name: bck-animation;
    animation-name: bck-animation; */
    animation: bck-animation 20s cubic-bezier(0.1, 0, 0.9, 1) infinite;
  }
}

@-webkit-keyframes bck-animation {
  0% {
    -webkit-transform: translate(-50% -50%) rotate(-25deg);
    transform: translate(-50% -50%) rotate(-25deg);
  }
  25% {
    -webkit-transform: translate(-20%, 0%) skew(-10deg, -10deg) rotate(60deg);
    transform: translate(-20%, 0%) skew(-10deg, -10deg) rotate(60deg);
  }
  50% {
    -webkit-transform: translate(0%, 20%) rotate(150deg);
    transform: translate(0%, 20%) rotate(150deg);
  }
  75% {
    -webkit-transform: translate(-25%, -10%) skew(10deg, 10deg) rotate(0deg);
    transform: translate(-25%, -10%) skew(10deg, 10deg) rotate(0deg);
  }
  100% {
    -webkit-transform: translate(-50%, -50%) rotate(-25deg);
    transform: translate(-50%, -50%) rotate(-25deg);
  }
}

@keyframes bck-animation {
  0% {
    -webkit-transform: translate(-50% -50%) rotate(-25deg);
    transform: translate(-50% -50%) rotate(-25deg);
  }
  25% {
    -webkit-transform: translate(-20%, 0%) skew(-10deg, -10deg) rotate(60deg);
    transform: translate(-20%, 0%) skew(-10deg, -10deg) rotate(60deg);
  }
  50% {
    -webkit-transform: translate(0%, 20%) rotate(150deg);
    transform: translate(0%, 20%) rotate(150deg);
  }
  75% {
    -webkit-transform: translate(-25%, -10%) skew(10deg, 10deg) rotate(0deg);
    transform: translate(-25%, -10%) skew(10deg, 10deg) rotate(0deg);
  }
  100% {
    -webkit-transform: translate(-50%, -50%) rotate(-25deg);
    transform: translate(-50%, -50%) rotate(-25deg);
  }
}

/* */
</style>
